import React, { CSSProperties } from "react";

interface IPinchZoomImageProps {
  src: string;
  alt?: string;
  style?: CSSProperties;
  className?: string;
}


class PinchZoomImage extends React.Component<IPinchZoomImageProps> {
  private imageRef: React.RefObject<HTMLImageElement>;
  private containerRef: React.RefObject<HTMLImageElement>; 

  private initialDistance: number | null;
  private initialTouchX: number | null;
  private initialTouchY: number | null;
  private lastTranslateX: number;
  private lastTranslateY: number;
  private lastScale: number;
  private lastTouchCenter: { x: number; y: number } | null;

  private scale: number = 1;
  private translateX: number = 0;
  private translateY: number = 0;


  constructor(props: IPinchZoomImageProps) {
    super(props);
    this.imageRef = React.createRef();
    this.containerRef = React.createRef();
    this.initialDistance = null;
    this.initialTouchX = null;
    this.initialTouchY = null;
    this.lastTranslateX = 0;
    this.lastTranslateY = 0;
    this.lastScale = 1;
    this.lastTouchCenter = null;

  }
  public render() {
    const { src, alt } = this.props;

    return (
      <div
        ref={this.containerRef}
        style={{
          overflow: 'hidden',
          width: '100%',
          maxHeight: '250px',
          touchAction: 'none',
        }}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      >
        <img
          ref={this.imageRef}
          src={src}
          alt={alt}
          style={{
            transformOrigin:'top left',
            width: '100%',
            height: 'auto',
            display: 'block',
            userSelect: 'none',
            pointerEvents: 'auto',
          }}
        />
      </div>
    );
  }

  private handleTouchStart = (e: React.TouchEvent) => {
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      this.initialTouchX = touch.clientX;
      this.initialTouchY = touch.clientY;
    } else if (e.touches.length === 2) {
      const distance = this.getDistance(e.touches[0], e.touches[1]);
      const center = this.getCenter(e.touches[0], e.touches[1]);
      this.initialDistance = distance;
      this.lastScale = this.scale;
      this.lastTranslateX = this.translateX;
      this.lastTranslateY = this.translateY;
      this.lastTouchCenter = center;
    }
  };

  private handleTouchMove = (e: React.TouchEvent) => {

    if (e.touches.length === 1 && this.initialTouchX !== null && this.initialTouchY !== null) {
      const touch = e.touches[0];
      const deltaX = touch.clientX - this.initialTouchX;
      const deltaY = touch.clientY - this.initialTouchY;

      if (!this.imageRef.current || !this.containerRef.current) return;

      const imgHeight = this.imageRef.current.getBoundingClientRect().height || 0;
      const imgWidth = this.imageRef.current.getBoundingClientRect().width || 0;
      
      const containerHeight = this.containerRef.current.getBoundingClientRect().height || 0;
      const containerWidth = this.containerRef.current.getBoundingClientRect().width || 0;

      const deltaXMax = imgWidth-containerWidth;
      const deltaYMax = imgHeight - containerHeight;

      this.translateX = Math.min(0, Math.max(this.lastTranslateX + deltaX, -deltaXMax));
      this.translateY = Math.min(0, Math.max(this.lastTranslateY + deltaY, -deltaYMax));

    } else if (e.touches.length === 2 && this.initialDistance) {
      const distance = this.getDistance(e.touches[0], e.touches[1]);
      const scaleChange = distance / this.initialDistance;
      let newScale = this.lastScale * scaleChange;
      newScale = Math.max(1, Math.min(newScale, 3));

      const currentCenter = this.getCenter(e.touches[0], e.touches[1]);
      if (this.lastTouchCenter) {
        const deltaX = currentCenter.x - this.lastTouchCenter.x;
        const deltaY = currentCenter.y - this.lastTouchCenter.y;
        const imgHeight = this.imageRef.current?.getBoundingClientRect().height || 0;
        const imgWidth = this.imageRef.current?.getBoundingClientRect().width || 0;

        this.translateX = Math.max(-imgWidth, Math.min(this.lastTranslateX + deltaX, imgWidth));
        this.translateY = Math.max(-imgHeight, Math.min(this.lastTranslateY + deltaY, imgHeight));
      }
      this.lastTouchCenter = currentCenter;
      this.scale = newScale;
    }
    this.updateTransform(this.translateX, this.translateY, this.scale);
  };

  private handleTouchEnd = () => {
    this.lastTranslateX = this.translateX;
    this.lastTranslateY = this.translateY;
    this.initialTouchX = null;
    this.initialTouchY = null;
    this.initialDistance = null;
    this.lastTouchCenter = null;
  };

  private getDistance(touch1: React.Touch, touch2: React.Touch): number {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  private getCenter(touch1: React.Touch, touch2: React.Touch): { x: number; y: number } {
    return {
      x: (touch1.clientX + touch2.clientX) / 2,
      y: (touch1.clientY + touch2.clientY) / 2,
    };
  }

  private updateTransform(tX:number, tY:number, s:number) {

    if (this.imageRef.current) {
      this.imageRef.current.style.transform = `translate(${tX}px, ${tY}px) scale(${s})`;
    }
  }

  
}

export default PinchZoomImage;


// WEBPACK FOOTER //
// ./src/helpers/PinchZoomImage.tsx